<template>
  <div class="no-data">
    <span class="icon">
      <icon name="warning-border--no-color" />
    </span>
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "NoDataComponent",
  props: {
    text: String
  }
};
</script>

<style lang="scss">
.no-data {
  padding-top: 38px;
  padding-bottom: 42px;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #a7a7a7;
  background: var(--white, #fff);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.057971);
  @media (max-width: 1000px) {
    font-size: 16px;
    line-height: 18px;
  }
  @media (max-width: 540px) {
    padding-bottom: 35px;
    font-size: 14px;
    line-height: 16px;
  }

  span {
    display: inline-block;
    vertical-align: bottom;
    white-space: nowrap;

    &.icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      @media (max-width: 540px) {
        width: 17px;
        height: 17px;
        margin-right: 5px;
      }
    }
  }
  .svg-icon {
    width: 100%;
    height: 100%;
  }
}
</style>
